import type { ShowMode } from './types'

/**
 * Правила переходов режимов шторки при нажатии на левую кнопку:
 * Развернуть наполовину и свернуть полностью
 */
export const transformByPressLeftButton = (mode: ShowMode) => {
  switch (mode) {
    case 'none':
      return 'half'
    case 'half':
    case 'full':
      return 'none'
  }
}

/**
 * Правила переходов режимов шторки при нажатии на правую кнопку:
 * Раскрыть полностью и свернуть на половину
 */
export const transformByPressRightButton = (mode: ShowMode, noFullMode: boolean = false) => {
  switch (mode) {
    case 'none':
    case 'half':
      return noFullMode ? mode : 'full'
    case 'full':
      return 'half'
  }
}
